<script lang="ts">
    import type { SectionController, SectionInterface } from "@/Util/XertAm5";

    export let sections: SectionInterface[]
    export let sectionController: SectionController
    export let onSelectSection: (section: SectionInterface) => void = () => {};
    export let selectedSection: SectionInterface
</script>
<div role="tooltip" class="flex flex-col gap-2 flex-wrap overflow-auto" on:mouseleave={() => {if(!selectedSection) sectionController.removeSection()}}>
    {#each sections as section}
        <div role="button" tabindex="0" class="rounded border border-primary px-4 py-2"
            on:mouseenter={() => {if(!selectedSection) sectionController.showSection(section)}} 
            on:click={ () => {
                // const segmentInfo = await getStravaSegmentData(activity.path, segment.segment.id, segment.id)
                // segmentController.runStravaSegmentAnalysis({...segmentInfo, ...getSectionInterfaceFromSegment(segment)})
                onSelectSection(section)
            }}
            on:keypress={() => {}}
        >
            {section.name}
            <br/>
            <div class="text-muted-foreground text-sm">More Info Coming !</div>
        </div>
    {/each}
                                        
</div>